// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Accordion$Showside from "../components/Accordion.bs.js";
import * as PDPSelect$Showside from "../components/PDPSelect.bs.js";
import * as PDPSelectTypes$Showside from "../components/PDPSelectTypes.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function safeJsonParse(str) {
  try {
    return Caml_option.some(JSON.parse(str));
  } catch (e) {
    return;
  }
}
function fromJson(json) {
  return Belt_Array.map(Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.flatMap(Js_json.decodeString(json), safeJsonParse), Js_json.decodeArray), []), function (json) {
    return Belt_Array.reduce(Js_dict.entries(Belt_Option.getWithDefault(Js_json.decodeObject(json), {})), {
      color: "",
      link: ""
    }, function (acc, param) {
      var value = param[1];
      switch (param[0]) {
        case "color":
          return {
            color: Belt_Option.getWithDefault(Js_json.decodeString(value), ""),
            link: acc.link
          };
        case "link":
          return {
            color: acc.color,
            link: Belt_Option.getWithDefault(Js_json.decodeString(value), "")
          };
        default:
          return acc;
      }
    });
  });
}
function CustomerTheaterXyz$ColorPicker(Props) {
  var inline = Props.inline;
  var product = Props.product;
  EntrypointContext$Showside.use(undefined);
  ConfigurationProvider$Showside.use(undefined);
  RouterProvider$Showside.useRouter(undefined);
  var match = EntrypointContext$Showside.use(undefined);
  var redirectToLink = match.redirectToLink;
  var isMatch = Belt_Option.mapWithDefault(product.link, false, function (link) {
    return link.includes("theater.xyz");
  }) && !product.productType.toLowerCase().includes("perfume");
  var match$1 = Js_dict.get(product.metadata, "custom::swatch_multiple_variants");
  var swatches = match$1 !== undefined ? typeof match$1 === "number" ? [] : match$1.TAG === /* Json */9 ? isMatch ? fromJson(match$1._0) : [] : [] : [];
  if (swatches.length <= 1) {
    return null;
  }
  var tmp = {
    options: Belt_Array.map(swatches, function (swatch) {
      return PDPSelectTypes$Showside.makeOption("", "metafield-driven-color", swatch.color.startsWith("#") ? {
        TAG: /* ColorSwatch */1,
        _0: swatch.color
      } : {
        TAG: /* ImageSwatch */0,
        _0: "https://theater.xyz/cdn/shop/files/" + swatch.color
      }, !Product$Showside.isInStock(product), false, swatch.color, "Color: " + swatch.color, swatch.link);
    }),
    kind: /* SwatchButton */1,
    circular: true,
    value: Belt_Option.getWithDefault(product.link, ""),
    onChange: function (value) {
      Belt_Option.forEach(value, function (eta) {
        Curry._5(redirectToLink, undefined, undefined, undefined, undefined, eta);
      });
    }
  };
  var tmp$1 = inline ? 1 : undefined;
  if (tmp$1 !== undefined) {
    tmp.truncateAt = tmp$1;
  }
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make([inline ? "mr-6" : "mt-6 mb-6"]))
  }, React.createElement(Accordion$Showside.Header.make, {
    active: product.id,
    id: product.id,
    className: CSS$Showside.prefix("pb-2"),
    children: "Color"
  }), React.createElement(PDPSelect$Showside.make, tmp));
}
CustomerTheaterXyz$ColorPicker.displayName = "CustomerTheaterXyz.ColorPicker";
var ColorPicker = {
  make: CustomerTheaterXyz$ColorPicker
};
export { safeJsonParse, fromJson, ColorPicker };
/* react Not a pure module */